import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import colors from 'theme/colors';
import ScrollRow from './ScrollRow';

const accent = colors.occasionalPurple;

export default function GuestsPicker({ value, max, onChange }) {
    const selectedRef = useRef(null);

    useEffect(() => {
        selectedRef.current?.scrollIntoView?.({ block: 'nearest', inline: 'nearest' });
    }, [value, max]);

    const options = Array.from({ length: max || 0 }, (_, i) => i + 1);

    return (
        <ScrollRow ariaLabel='Número de pessoas'>
            {options.map(n => (
                <Pill
                    key={n}
                    type='button'
                    ref={n === value ? selectedRef : null}
                    $selected={n === value}
                    aria-pressed={n === value}
                    onClick={() => onChange(n)}
                >
                    {n}
                </Pill>
            ))}
        </ScrollRow>
    );
}

const Pill = styled.button`
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1.5px solid ${({ $selected }) => ($selected ? accent : colors.neutralDark)};
    background: ${({ $selected }) => ($selected ? accent : '#fff')};
    color: ${({ $selected }) => ($selected ? '#fff' : colors.nightDark)};
    font-size: 14px;
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
`;
